import { useState, useEffect } from "react";
import "./BlogListing.scss";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import CardImg from "../../assests/img/card.svg";
import IpadImg from "../../assests/img/ipad.svg";
import blogImg from "../../assests/img/blog1.png";
import Label from "../../components/Label/Label";
import Footer from "../../components/Footer/Footer";
import { fetchBlogList } from "../../services/blogApi";
import { buildBlogPath } from "../../util/slugId";
import { getBlogImage } from "../../util/mediaHelpers";
import Seo from "../../components/Seo/Seo";
import { PAGE_SEO } from "../../config/seoConfig";

const BlogListing = () => {
  const navigate = useNavigate();
  const [carousalStatus, setCarousalStatus] = useState(true);
  const [blogItems, setBlogItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleClick = (data) => {
    setCarousalStatus(data);
  };

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const items = await fetchBlogList();
        setBlogItems(items);
      } catch (error) {
        console.error("Failed to load blogs", error);
        setBlogItems([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadBlogs();
    window.scrollTo(0, 0);
  }, []);

  const featuredBlog = blogItems[0];
  const heroTopic = featuredBlog?.topic || "Blog";
  const heroTitle = featuredBlog?.title || "Latest Insights";
  const heroDesc =
    featuredBlog?.desc ||
    "Explore our latest articles on technology, innovation, and digital transformation.";

  if (isLoading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <lottie-player
            autoplay
            loop
            src="https://lottie.host/7d0ba31f-e11f-47ed-8248-b1a8f5389ad8/oMZAHSKOuQ.json"
          ></lottie-player>
        </div>
      </div>
    );
  }

  return (
    <div className="bloglisting_Page">
      <Seo {...PAGE_SEO.blog} />
      <div className="center-blog-section">
        <Header handleClick={handleClick} />
        <div className="headerImg">
          <img src={blogImg} className="blog_Img" alt="Digipank blog" />
          <div className="content_Section">
            <Label className="main_Heading" title={heroTopic}></Label>
            <Label className="heading" title={heroTitle}></Label>
            <div className="inner_TxtSection">
              <p className="inner_Txt">
                {heroDesc}
                {featuredBlog && (
                  <div
                    className="read_More cursorP"
                    onClick={() => navigate(buildBlogPath(featuredBlog.id))}
                  >
                    {featuredBlog.btnTitle || "Read More"}
                  </div>
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="card_Section">
          {blogItems.map((element) => {
            return (
              <div
                className="card_Main cursorP"
                key={element.id}
                onClick={() => navigate(buildBlogPath(element.id))}
              >
                <div className="img_Section">
                  <img
                    src={getBlogImage(element, CardImg)}
                    className="blog_Img displayDesktop"
                    alt={`${element.title || "Blog"} blog cover`}
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      e.currentTarget.parentElement.classList.add(
                        "image-error",
                      );
                    }}
                  />

                  <img
                    src={getBlogImage(element, IpadImg)}
                    className="blog_Img displayIpad"
                    alt={`${element.title || "Blog"} blog cover`}
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      e.currentTarget.parentElement.classList.add(
                        "image-error",
                      );
                    }}
                  />

                  <div className="image-na">NA</div>

                  <div className="date_Section">
                    <span className="date">{element.date || "Today"}</span>
                  </div>
                </div>
                <div className="content_Section">
                  <Label className="main_Heading" title={element.topic}></Label>
                  <Label className="heading" title={element.title}></Label>
                  <div className="inner_TxtSection">
                    <p className="inner_Txt">
                      {element.desc}
                      <span className="read_More">
                        {element.btnTitle || "Read More"}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default BlogListing;
